import { render, staticRenderFns } from "./PhysicianEdit.vue?vue&type=template&id=5c2b0079&"
import script from "./PhysicianEdit.vue?vue&type=script&lang=js&"
export * from "./PhysicianEdit.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports